import { IContraceptionClient } from "@interfaces";

interface IParams {
  dmpa_im_New_client_Under_25: number,
  dmpa_im_New_client_Over_25: number,
  dmpa_im_Old_client_Under_25: number,
  dmpa_im_Old_client_Over_25: number,
  oc_pill_New_client_Under_25: number,
  oc_pill_New_client_Over_25: number,
  oc_pill_Old_client_Under_25: number,
  oc_pill_Old_client_Over_25: number,
}

export const getTransformObjectToArray = (contraceptionClients: IParams): IContraceptionClient[] => {
  const clientInfos = [];
  const { 
    dmpa_im_New_client_Under_25,
    dmpa_im_New_client_Over_25,
    dmpa_im_Old_client_Under_25,
    dmpa_im_Old_client_Over_25,
    oc_pill_New_client_Under_25,
    oc_pill_New_client_Over_25,
    oc_pill_Old_client_Under_25,
    oc_pill_Old_client_Over_25,    
   } = contraceptionClients;
  if(dmpa_im_New_client_Under_25) {
    clientInfos.push({
      consultation: 'DMPA_IM',
      clientRole: 'New_Client',
      clientAge: 'Under_25',
      doseCount: dmpa_im_New_client_Under_25,
    });
  }
  if(dmpa_im_New_client_Over_25) {
    clientInfos.push({
      consultation: 'DMPA_IM',
      clientRole: 'New_Client',
      clientAge: 'Over_25',
      doseCount: dmpa_im_New_client_Over_25,
    });
  }
  if(dmpa_im_Old_client_Under_25) {
    clientInfos.push({
      consultation: 'DMPA_IM',
      clientRole: 'Old_Client',
      clientAge: 'Under_25',
      doseCount: dmpa_im_Old_client_Under_25,
    });
  }
  if(dmpa_im_Old_client_Over_25) {
    clientInfos.push({
      consultation: 'DMPA_IM',
      clientRole: 'Old_Client',
      clientAge: 'Over_25',
      doseCount: dmpa_im_Old_client_Over_25,
    });
  }
  if(oc_pill_New_client_Under_25) {
    clientInfos.push({
      consultation: 'OC_PILL',
      clientRole: 'New_Client',
      clientAge: 'Under_25',
      doseCount: oc_pill_New_client_Under_25,
    });
  }
  if(oc_pill_New_client_Over_25) {
    clientInfos.push({
      consultation: 'OC_PILL',
      clientRole: 'New_Client',
      clientAge: 'Over_25',
      doseCount: oc_pill_New_client_Over_25,
    });
  }
  if(oc_pill_Old_client_Under_25) {
    clientInfos.push({
      consultation: 'OC_PILL',
      clientRole: 'Old_Client',
      clientAge: 'Under_25',
      doseCount: oc_pill_Old_client_Under_25,
    });
  }
  if(oc_pill_Old_client_Over_25) {
    clientInfos.push({
      consultation: 'OC_PILL',
      clientRole: 'Old_Client',
      clientAge: 'Over_25',
      doseCount: oc_pill_Old_client_Over_25,
    });
  }
  return clientInfos;
};

export const getTransformArrayToObject = (contraceptionClients: IContraceptionClient[]): IParams => {
  const dmpa_im_NewClientUnder25 = contraceptionClients.filter(item => item.consultation === "DMPA_IM" && item.clientRole === "New_Client" && item.clientAge === "Under_25");
  const dmpa_im_NewClientOver25 = contraceptionClients.filter(item => item.consultation === "DMPA_IM" && item.clientRole === "New_Client" && item.clientAge === "Over_25");
  const dmpa_im_OldClientUnder25 = contraceptionClients.filter(item => item.consultation === "DMPA_IM" && item.clientRole === "Old_Client" && item.clientAge === "Under_25");
  const dmpa_im_OldClientOver25 = contraceptionClients.filter(item => item.consultation === "DMPA_IM" && item.clientRole === "Old_Client" && item.clientAge === "Over_25");
  const oc_pill_NewClientUnder25 = contraceptionClients.filter(item => item.consultation === "OC_PILL" && item.clientRole === "New_Client" && item.clientAge === "Under_25");
  const oc_pill_NewClientOver25 = contraceptionClients.filter(item => item.consultation === "OC_PILL" && item.clientRole === "New_Client" && item.clientAge === "Over_25");
  const oc_pill_OldClientUnder25 = contraceptionClients.filter(item => item.consultation === "OC_PILL" && item.clientRole === "Old_Client" && item.clientAge === "Under_25");
  const oc_pill_OldClientOver25 = contraceptionClients.filter(item => item.consultation === "OC_PILL" && item.clientRole === "Old_Client" && item.clientAge === "Over_25");

  return {
    dmpa_im_New_client_Under_25: dmpa_im_NewClientUnder25.length > 0 ? dmpa_im_NewClientUnder25[0].doseCount : 0,
    dmpa_im_New_client_Over_25: dmpa_im_NewClientOver25.length > 0 ? dmpa_im_NewClientOver25[0].doseCount : 0,
    dmpa_im_Old_client_Under_25: dmpa_im_OldClientUnder25.length > 0 ? dmpa_im_OldClientUnder25[0].doseCount : 0,
    dmpa_im_Old_client_Over_25: dmpa_im_OldClientOver25.length > 0 ? dmpa_im_OldClientOver25[0].doseCount : 0,
    oc_pill_New_client_Under_25: oc_pill_NewClientUnder25.length > 0 ? oc_pill_NewClientUnder25[0].doseCount : 0,
    oc_pill_New_client_Over_25: oc_pill_NewClientOver25.length > 0 ? oc_pill_NewClientOver25[0].doseCount : 0,
    oc_pill_Old_client_Under_25: oc_pill_OldClientUnder25.length > 0 ? oc_pill_OldClientUnder25[0].doseCount : 0,
    oc_pill_Old_client_Over_25: oc_pill_OldClientOver25.length > 0 ? oc_pill_OldClientOver25[0].doseCount : 0,
  };
};

export const doseCountForDMPA_IM = (clientData: any, client_info: string, doseCount: number): any => {
  if(client_info === 'new_client_under_25') {
    clientData = {...clientData, dmpa_im_New_client_Under_25: doseCount};
  }
  if(client_info === 'new_client_over_25') {
    clientData = {...clientData, dmpa_im_New_client_Over_25: doseCount};
  }

  if(client_info === 'old_client_under_25') {
    clientData = {...clientData, dmpa_im_Old_client_Under_25: doseCount};
  }
  if(client_info === 'old_client_over_25') {
    clientData = {...clientData, dmpa_im_Old_client_Over_25: doseCount};
  }

  return clientData;
};

export const doseCountForOC_PILL = (clientData: any, client_info: string, doseCount: number): any => {
  if(client_info === 'new_client_under_25') {
    clientData = {...clientData, oc_pill_New_client_Under_25: doseCount};
  }
  if(client_info === 'new_client_over_25') {
    clientData = {...clientData, oc_pill_New_client_Over_25: doseCount};
  }

  if(client_info === 'old_client_under_25') {
    clientData = {...clientData, oc_pill_Old_client_Under_25: doseCount};
  }
  if(client_info === 'old_client_over_25') {
    clientData = {...clientData, oc_pill_Old_client_Over_25: doseCount};
  }

  return clientData;
};